import { render, staticRenderFns } from "./jd-loading-new.vue?vue&type=template&id=157e9d5b&scoped=true"
import script from "./jd-loading-new.vue?vue&type=script&lang=js"
export * from "./jd-loading-new.vue?vue&type=script&lang=js"
import style0 from "./jd-loading-new.vue?vue&type=style&index=0&id=157e9d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e9d5b",
  null
  
)

export default component.exports